/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'sortBy' })
@Injectable()
export class SortByPipe implements PipeTransform {
  transform(array: any, field: string, order: string): any[] {
    if (!Array.isArray(array) || !field || !order) {
      return array;
    }
    array.sort((a: any, b: any) => {
      let aVal = a[field],
        bVal = b[field];

      if (typeof aVal === 'undefined' || typeof bVal === 'undefined') {
        return 0;
      }

      // sort by string
      if (isNaN(aVal) && isNaN(bVal)) {
        aVal = (aVal as string).toUpperCase();
        bVal = (bVal as string).toUpperCase();
        if (aVal < bVal) {
          return -1;
        } else if (aVal > bVal) {
          return 1;
        } else {
          return 0;
        }
      }

      // sort by number
      return aVal - bVal;
    });

    if (order == 'sort-desc') {
      array.reverse();
    }

    return array;
  }
}
